<template>
	<el-table v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-table>
</template>
<script>
export default {
  name: "aia-table",
};
</script>